import Model from './model'

export default class Page extends Model {
  constructor() {
    super()
    this.hydrate({
      title: '',
      slug: '',
      body: '',
    })
  }
}